import { Injectable } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";


@Injectable({
    providedIn: 'root'
})
export class SeoMetaTagService {
    public SetMetaTitleByUrl(url: string) {
        let title = this.resolveMetaTitleByUrl(url);
        this.SetMetaTitle(title);
    }

    public SetMetaTitle(title: string) {
        const metaTitle = document.querySelector('meta[name="title"]');
        if (metaTitle) {
            metaTitle.setAttribute('content', title);
        } else {
            const newMetaTitle = document.createElement('meta');
            newMetaTitle.setAttribute('name', 'title');
            newMetaTitle.setAttribute('content', title);
            document.head.appendChild(newMetaTitle);
        }
        document.title = title;
    }

    public SetMetaDescriptionByUrl(url: string) {
        let description = this.resolveMetaDesciptionByUrl(url);
        this.SetMetaDescription(description);
    }

    public SetMetaDescription(description: string) {
        const metaTitle = document.querySelector('meta[name="description"]');
        if (metaTitle) {
            metaTitle.setAttribute('content', description);
        } else {
            const newMetaTitle = document.createElement('meta');
            newMetaTitle.setAttribute('name', 'description');
            newMetaTitle.setAttribute('content', description);
            document.head.appendChild(newMetaTitle);
        }
    }

    public SetTwitterCard() {
        const twitterMeta = document.querySelector('meta[name="twitter:card"]');
        if (twitterMeta) {
            twitterMeta.setAttribute('content', 'summary_large_image');
        } else {
            const newMetaOg = document.createElement('meta');
            newMetaOg.setAttribute('name', 'twitter:card');
            newMetaOg.setAttribute('content', 'summary_large_image');
            document.head.appendChild(newMetaOg);
        }
    }

    public SetOgMeta(property: string, content: string) {
        const ogMeta = document.querySelector('meta[property="og:' + property + '"]');
        if (ogMeta) {
            ogMeta.setAttribute('content', content);
        } else {
            const newMetaOg = document.createElement('meta');
            newMetaOg.setAttribute('property', "og:" + property);
            newMetaOg.setAttribute('content', content);
            document.head.appendChild(newMetaOg);
        }
    }

    public SetMetaCanonicalLinkByUrl(url: string) {
        let canonicalUrl = this.resolveMetaCanonicalLinkByUrl(url);
        if (canonicalUrl == '') {
            const metaCanonical = document.querySelector('link[rel="canonical"]');
            if (metaCanonical) {
                metaCanonical.remove();
            }
        }
        else {
            const metaCanonical = document.querySelector('link[rel="canonical"]');
            if (metaCanonical) {
                metaCanonical.setAttribute('href', canonicalUrl);
            } else {
                const newMetaTitle = document.createElement('link');
                newMetaTitle.setAttribute('rel', 'canonical');
                newMetaTitle.setAttribute('href', canonicalUrl);
                document.head.appendChild(newMetaTitle);
            }
        }
    }

    private resolveMetaDesciptionByUrl(url: string): string {
        if (url.includes('home')) {
            return 'Αγόρασε ή πούλησε το ακίνητό σου εύκολα και γρήγορα με το Uniko, τον νέο τρόπο αγοραπωλησίας ακινήτων. Με την υποστήριξη της Εθνικής Τράπεζας.';
        } else if (url.includes('terms-and-conditions')) {
            return 'Διάβασε τους Όρους & Προϋποθέσεις του Uniko και μάθε πώς λειτουργούν οι υπηρεσίες μας. Ενημερώσου για τα δικαιώματα σου εύκολα και με διαφάνεια.';
        } else if (url.includes('privacy-policy')) {
            return 'Μάθε πώς το Uniko διαχειρίζεται και προστατεύει τα προσωπικά σου δεδομένα. Διάβασε την Πολιτική Απορρήτου μας & ενημερώσου για τα δικαιώματά σου.';
        } else if (url.includes('sell-property-get-started')) {
            return 'Πούλησε το ακίνητό σου γρήγορα & με ασφάλεια! Κάνε το πρώτο βήμα με το Uniko, λάβε σωστή εκτίμηση & φτάσε στην καλύτερη συμφωνία με υποστήριξη.';
        } else if (url.includes('sell-with-us')) {
            return 'Πούλησε το ακίνητό σου γρήγορα & με ασφάλεια! Κάνε το πρώτο βήμα με το Uniko, λάβε σωστή εκτίμηση & φτάσε στην καλύτερη συμφωνία με υποστήριξη.';
        } else if (url.includes('loan-eligibility')) {
            return 'Κάνε υπολογισμό στεγαστικού δανείου εύκολα & γρήγορα στο Uniko! Βρες τη δόση σου με ευέλικτα επιτόκια και πάρε έγκριση από την Εθνική Τράπεζα!';
        } else if (url.includes('contact')) {
            return 'Έχεις απορίες ή χρειάζεσαι καθοδήγηση; Επικοινώνησε με έναν ειδικό του Uniko και πάρε άμεσες απαντήσεις για την αγορά ή πώληση ακινήτου.';
        } else if (url.includes('cookies-settings')) {
            return 'Επίλεξε πώς χρησιμοποιούμε τα cookies για να βελτιώσουμε την εμπειρία σου στο Uniko. Ρύθμισε τις προτιμήσεις σου εύκολα & με απόλυτη διαφάνεια.';
        } else if (url.includes('register')) {
            return 'Κάνε εγγραφή στο Uniko για πρόσβαση σε αναλύσεις ακινήτων, αποκλειστικές υπηρεσίες και ειδικούς. Ξεκίνησε εύκολα την πώληση ή αγορά του ακινήτου σου!';
        } else if (url.includes('login')) {
            return 'Συνδέσου στο Uniko για να δεις λεπτομέρειες της αγοράς ή πώλησης του ακινήτου σου. Έλεγξε αναλύσεις, προσφορές & προχώρα στο επόμενο βήμα με σιγουριά!';
        } else if (url.includes('on-boarding-buyer')) {
            return 'Αγόρασε το ιδανικό ακίνητο με το Uniko! Σε συνεργασία με την Εθνική Τράπεζα, απολαμβάνεις διαφάνεια, ασφάλεια & καθοδήγηση σε κάθε στάδιο της διαδικασίας.';
        } else if (url.includes('on-boarding-seller')) {
            return 'Ξεκίνα την πώληση του ακινήτου με το Uniko! Το πρώτο ψηφιακό μεσιτικό γραφείο στην Αθήνα, σε συνεργασία με την Εθνική Τράπεζα, που εξασφαλίζει διαφάνεια & ασφάλεια.';
        } else if (url.includes('faq')) {
            return 'Έχεις απορίες για τη διαδικασία αγοράς ή πώλησης ακινήτου; Δες τις συχνές ερωτήσεις και ανακάλυψε πώς το Uniko απλοποιεί κάθε στάδιο!';
        } else if (url.includes('about')) {
            return 'Ανακάλυψε το Uniko, την πλατφόρμα που αλλάζει την αγοραπωλησία ακινήτων στην Ελλάδα. Με εξειδίκευση & διαφάνεια, κάνουμε τη διαδικασία πιο εύκολη!';
        } else if (url.includes('financing')) {
            return 'Απόκτησε το σπίτι σου με στεγαστικό δάνειο και ευέλικτα επιτόκια από την Εθνική Τράπεζα ή πάρει δάνειο ανακαίνισης με το Uniko.';
        } else if (url.includes('services')) {
            return 'Βρες ολοκληρωμένες υπηρεσίες για την αγορά ή πώληση ακινήτου! Το Uniko αναλαμβάνει εκτίμηση, νομικό έλεγχο & διαπραγματεύσεις για ασφαλείς συναλλαγές.';
        } else if (url.includes('properties')) {
            return 'Ανακάλυψε μοναδικές ευκαιρίες για αγορά σπιτιού, ακινήτου ή κατοικίας. Περιηγήσου στις καταχωρίσεις του Uniko & βρες το ιδανικό ακίνητο εύκολα!';
        } else if (url.includes('legalReport')) {
            return 'Εξασφάλισε πλήρη νομικό έλεγχο ακινήτου πριν την αγορά ή πώληση. Το Uniko, σε συνεργασία με ειδικούς, σου παρέχει διαφάνεια & ασφάλεια σε κάθε συναλλαγή.';
        } else if (url.includes('technicalReport')) {
            return 'Μάθε τα πάντα για ένα ακίνητο πριν την αγοραπωλησία. Με την Έκθεση εκτίμησης του Uniko, έχεις πλήρη εικόνα της κατάστασής του!';
        } else if (url.includes('preapproval')) {
            return 'Πιστοποίησε το ακίνητό σου και μάθε ό,τι χρειάζεσαι για γρήγορο συμβόλαιο! Προσέλκυσε περισσότερους αγοραστές με την αξιοπιστία της Εθνικής Τράπεζας.';
        } else if (url.includes('propertyFileConstitution')) {
            return 'Διασφάλισε ότι ο φάκελος του ακινήτου σου είναι πλήρης! Το Uniko σε βοηθά να συγκεντρώσεις όλα τα απαραίτητα έγγραφα για μια ομαλή αγοραπωλησία.';
        } else if (url.includes('photography')) {
            return 'Κάνε το ακίνητό σου να ξεχωρίσει με ψηφιακή περιήγηση και επαγγελματική φωτογράφιση από το Uniko! Προσέλκυσε αγοραστές & πούλησέ το γρηγορότερα.';
        }

        return '';
    }

    private resolveMetaTitleByUrl(url: string): string {
        if (url.includes('home')) {
            return 'Uniko: Ένας Νέος Καλύτερος Τρόπος Αγοραπωλησίας Ακινήτων';
        } else if (url.includes('terms-and-conditions')) {
            return 'Όροι Χρήσης | Uniko';
        } else if (url.includes('privacy-policy')) {
            return 'Πολιτική Απορρήτου | Uniko';
        } else if (url.includes('sell-property-get-started')) {
            return 'Πώληση Κατοικιών & Ακινήτων | Uniko';
        } else if (url.includes('sell-with-us')) {
            return 'Πώληση Κατοικιών | Ακινήτων | Σπιτιών | Uniko';
        } else if (url.includes('loan-eligibility')) {
            return 'Yπολογισμός Στεγαστικού Δανείου | Uniko';
        } else if (url.includes('contact')) {
            return 'Επικοινωνία | Uniko';
        } else if (url.includes('cookies-settings')) {
            return 'Πολιτική Cookies | Uniko';
        } else if (url.includes('register')) {
            return 'Δημιουργία Λογαριασμού | Uniko';
        } else if (url.includes('login')) {
            return 'Είσοδος Χρήστη | Uniko';
        } else if (url.includes('on-boarding-buyer')) {
            return 'Aίτηση Ενδιαφέροντος για Αγορά Ακινήτου | Uniko';
        } else if (url.includes('on-boarding-seller')) {
            return 'Aίτηση Ενδιαφέροντος για Πώληση Ακινήτου | Uniko';
        } else if (url.includes('faq')) {
            return 'Συχνές Ερωτήσεις για την αγοραπωλησία ακινήτων | Uniko';
        } else if (url.includes('about')) {
            return 'Σχετικά με εμάς | Uniko';
        } else if (url.includes('financing')) {
            return 'Στεγαστικό Δάνειο | Χρηματοδότηση για αγορά ακινήτου | Uniko';
        } else if (url.includes('services')) {
            return 'Οι υπηρεσίες μας | Uniko';
        } else if (url.includes('properties')) {
            return 'Αγορά Σπιτιών | Κατοικιών | Ακινήτων | Uniko';
        } else if (url.includes('legalReport')) {
            return 'Νομικός Έλεγχος Ακινήτου | Uniko';
        } else if (url.includes('technicalReport')) {
            return 'Έκθεση Εκτίμησης Ακινήτου | Uniko';
        } else if (url.includes('preapproval')) {
            return 'Πιστοποίηση Ακινήτου από την Εθνική Τράπεζα | Uniko';
        } else if (url.includes('propertyFileConstitution')) {
            return 'Σύσταση Φακέλου Ακινήτου | Uniko';
        } else if (url.includes('photography')) {
            return 'Επαγγελματική Φωτογράφιση Ακινήτων | Uniko';
        }
        return 'Uniko';
    }

    private resolveMetaCanonicalLinkByUrl(url: string): string {
        if (url === '/') {
            return 'https://www.uniko.gr/el/home"';
        }
        // Handle property URLs
        if (url.startsWith('/properties/')) {
            return `https://www.uniko.gr/el${url}`;
        }
        return '';
    }
}